import request from '@/utils/request'
import {cmsServerContext} from '@/config/config'

/**
 * 报警查询
 * @param approach
 */
export function selectWarningRecord(condition) {
  return request({
    url: cmsServerContext + '/warningRecord/selectWarningRecord',
    method: 'post',
    data: condition,
    timeout: 1000 * 60 * 10
  })
}

/**
 * 报警类型查询
 * @param customerId
 */
export function selectWarningRecordType(customerId) {
  return request({
    url: cmsServerContext + '/warningRecord/selectWarningRecordType/' + customerId,
    method: 'get'
  })
}

/**
 * 报警类型查询
 * @param customerId
 */
export function selectRoleWarningType(customerRoleId) {
  return request({
    url: cmsServerContext + '/warningRecord/selectRoleWarningType/' + customerRoleId,
    method: 'post'
  })
}

/**
 * 未处理报警分页查询
 * @param customerId
 */
export function getUntreatedWarningRecordByPage(condition) {
  return request({
    url: cmsServerContext + '/warningRecord/getUntreatedWarningRecordByPage',
    method: 'post',
    data: condition
  })
}

/**
 * 未处理报警查询
 * @param customerId
 */
export function getUntreatedWarningCount(customerId) {
  return request({
    url: cmsServerContext + '/warningRecord/getUntreatedWarningCount/' + customerId,
    method: 'get',
  })
}

/**
 * 未处理报警查询
 * @param customerId
 */
export function confirmWarningRecord(warningRecord) {
  return request({
    url: cmsServerContext + '/warningRecord/confirmWarningRecord',
    method: 'post',
    data: warningRecord
  })
}

export function saveWarningType(customerRoleId, warningTypeIds) {
  return request({
    url: cmsServerContext + '/warningRecord/saveWarningType/' + customerRoleId,
    method: 'post',
    data: warningTypeIds
  })
}

export function selectWarningRecordTypeCount(condition) {
  return request({
    url: cmsServerContext + '/warningRecord/selectWarningRecordTypeCount',
    method: 'post',
    data: condition
  })
}

export function getWarningRecordTypeMapping(customerId) {
  return request({
    url: cmsServerContext + '/warningRecord/getWarningRecordTypeMapping/' + customerId,
    method: 'get'
  })
}

/**
 * 格式化数据,将属性改为对应中文、格式化数据
 * @param data
 * @returns {*}
 */
export function formatTitle(data) {
  try {
    let array = [];
    for (let i in data) {

      let map = {}
      if (!myCheck(data[i].warningTime)) {
        map["报警时间"] = formatToDay(data[i].warningTime)
      }
      if (!myCheck(data[i].customerUserName)) {
        map["用户名称"] = data[i].customerUserName
      }
      if (!myCheck(data[i].customerUserId)) {
        map["用户编号"] = data[i].customerUserId
      }
      if (!myCheck(data[i].meterName)) {
        map["仪表名称"] = data[i].meterName
      }
      if (!myCheck(data[i].meterId)) {
        map["仪表编号"] = formatToDay(data[i].meterId)
      }
      if (!myCheck(data[i].meterNum)) {
        map["表号"] = formatToDay(data[i].meterNum)
      }
      if (!myCheck(data[i].warningTypeId)) {
        map["报警类型"] = formatToDay(data[i].warningTypeId)
      }
      if (!myCheck(data[i].type)) {
        map["报警状态"] = formatToDay(data[i].type)
      }
      if (!myCheck(data[i].operator)) {
        map["处理人"] = formatToDay(data[i].operator)
      }
      if (!myCheck(data[i].operatingTime)) {
        map["处理时间"] = formatToDay(data[i].operatingTime)
      }
      array.push(map)
    }
    return array;
  } catch (e) {
    return null;
  }

}

export function myCheck(...values) { /* true为空 */
  if (typeof values === undefined || values === null || values === '') return true
  let ret = true
  for (let i = 0; i < values.length; i++) {
    ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
    if (ret === false) break
  }
  return ret
}

export function selectConfigRecord(condition) {
  return request({
    url: cmsServerContext + '/batchSettingRecord/getByPage',
    method: 'post',
    data: condition
  })
}
